"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-[30px] flex flex-col"
};
const _hoisted_2 = { class: "grow" };
const _hoisted_3 = { class: "hidden xl:flex font-bold uppercase py-3 border-b-2 border-[#E1E1E1]" };
const _hoisted_4 = { class: "flex grow justify-start items-center text-center" };
const _hoisted_5 = { class: "flex flex-[0_0_150px] justify-start items-center text-center" };
const _hoisted_6 = { class: "flex flex-[0_0_150px] justify-center items-center text-center" };
const _hoisted_7 = { class: "flex flex-[0_0_150px] justify-end items-center text-center" };
const _hoisted_8 = { class: "flex flex-[0_0_150px] justify-end items-center text-center" };
const _hoisted_9 = ["id"];
const _hoisted_10 = { class: "xl:grow flex items-center border-b-1 xl:border-0 border-gray py-3 xl:py-0" };
const _hoisted_11 = { class: "xl:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = { class: "xl:flex-[0_0_150px] flex items-center justify-end border-b-1 xl:border-0 border-gray py-3 xl:py-0" };
const _hoisted_14 = { class: "xl:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = { class: "xl:flex-[0_0_150px] flex items-center justify-end border-b-1 xl:border-0 border-gray py-3 xl:py-0" };
const _hoisted_17 = { class: "xl:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_18 = { class: "grow text-right xl:text-center" };
const _hoisted_19 = { class: "xl:flex-[0_0_150px] flex items-center justify-end border-b-1 xl:border-0 border-gray py-3 xl:py-0" };
const _hoisted_20 = { class: "xl:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_21 = { class: "grow text-right" };
const _hoisted_22 = { class: "xl:flex-[0_0_150px] flex items-center justify-end py-3 xl:py-0" };
const _hoisted_23 = { class: "xl:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_24 = {
    key: 0,
    class: "grow text-right"
};
const _hoisted_25 = {
    key: 1,
    class: "grow text-right"
};
const _hoisted_26 = {
    key: 0,
    id: "checkout-cart-summary-price-summary",
    class: "mb-3 border-t-2 border-b-2 border-[#929292] mt-[30px]"
};
const _hoisted_27 = {
    key: 0,
    class: "flex py-[6px]"
};
const _hoisted_28 = { class: "grow font-bold" };
const _hoisted_29 = { class: "flex-[0_0_150px] text-right" };
const _hoisted_30 = { class: "flex py-[6px]" };
const _hoisted_31 = { class: "grow font-bold" };
const _hoisted_32 = { class: "flex-[0_0_150px] text-right" };
const _hoisted_33 = {
    key: 1,
    class: "flex py-[6px]"
};
const _hoisted_34 = { class: "grow font-bold" };
const _hoisted_35 = { class: "flex-[0_0_150px] text-right" };
const _hoisted_36 = { class: "flex py-[6px]" };
const _hoisted_37 = { class: "grow font-bold" };
const _hoisted_38 = { class: "flex-[0_0_150px] text-right" };
const _hoisted_39 = {
    key: 2,
    class: "flex py-[6px]"
};
const _hoisted_40 = { class: "grow font-bold" };
const _hoisted_41 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_42 = {
    key: 3,
    class: "flex py-[6px]"
};
const _hoisted_43 = { class: "grow font-bold" };
const _hoisted_44 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_45 = {
    key: 4,
    class: "flex py-[6px]"
};
const _hoisted_46 = { class: "grow font-bold" };
const _hoisted_47 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_48 = {
    key: 5,
    class: "flex py-[6px]"
};
const _hoisted_49 = { class: "grow font-bold" };
const _hoisted_50 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_51 = {
    key: 6,
    class: "flex py-[6px]"
};
const _hoisted_52 = { class: "grow font-bold" };
const _hoisted_53 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_54 = {
    key: 7,
    class: "flex py-[6px]"
};
const _hoisted_55 = { class: "grow font-bold" };
const _hoisted_56 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_57 = {
    key: 8,
    class: "flex py-[6px]"
};
const _hoisted_58 = { class: "grow font-bold" };
const _hoisted_59 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_60 = {
    key: 9,
    class: "flex py-[6px]"
};
const _hoisted_61 = { class: "grow font-bold" };
const _hoisted_62 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_63 = {
    key: 10,
    class: "flex py-[6px]"
};
const _hoisted_64 = { class: "grow font-bold" };
const _hoisted_65 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_66 = {
    key: 11,
    class: "flex py-[6px]"
};
const _hoisted_67 = { class: "grow font-bold" };
const _hoisted_68 = {
    key: 0,
    class: "flex-[0_0_150px] text-right"
};
const _hoisted_69 = {
    key: 12,
    class: "flex py-[6px]"
};
const _hoisted_70 = { class: "grow font-bold" };
const _hoisted_71 = { class: "flex-[0_0_150px] text-right font-bold text-[18px]" };
const _hoisted_72 = {
    key: 1,
    class: "flex py-[6px>"
};
const _hoisted_73 = { class: "grow" };
const _hoisted_74 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "relative top-0.5 marso-icon-recycle text-green pr-1" }, null, -1);
const _hoisted_75 = { class: "flex-[0_0_150px] text-right" };
const vue_3 = require("vue");
const shop_1 = require("../../common/utils/shop");
const i18n_1 = require("../../common/i18n");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const securityStore_1 = require("../../stores/security/securityStore");
const checkoutStore_1 = require("../../stores/checkout/checkoutStore");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartSummary',
    setup(__props) {
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const checkoutStore = (0, checkoutStore_1.useCheckoutStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const activeCartProducts = (0, vue_3.computed)(() => {
            return activeCart.value === undefined ? [] : activeCart.value.products;
        });
        const extraFees = (0, vue_3.computed)(() => checkoutStore.extraFees);
        const grossTotalWithExtraFees = (0, vue_3.computed)(() => {
            var _a;
            if (activeCart.value === undefined) {
                return null;
            }
            if (extraFees.value === null) {
                return (_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.getGrossTotal();
            }
            return (activeCart.value.getGrossTotal() +
                extraFees.value.mandatoryCollectionFee +
                extraFees.value.courierShippingFee +
                extraFees.value.transferShippingFee +
                extraFees.value.expressShippingFee +
                extraFees.value.hungarianShippingFee +
                extraFees.value.accessoriesShippingFee +
                extraFees.value.pickUpShippingFee +
                extraFees.value.glsFlexDeliveryShippingFee +
                extraFees.value.administrationFee +
                extraFees.value.bexShippingFee);
        });
        const customerCurrencyCode = (0, vue_3.computed)(() => {
            if (securityStore.authenticatedUser !== null) {
                return securityStore.authenticatedUser.customer.currencyCode;
            }
            return "";
        });
        const eprPriceGrossTotal = (0, vue_3.computed)(() => {
            let total = 0;
            if (activeCartProducts.value.length) {
                total = activeCartProducts.value.reduce((subTotal, current) => {
                    return subTotal + (current.priceEpr * current.quantity) * (1 + current.priceVatPercent / 100);
                }, 0);
            }
            return total;
        });
        return (_ctx, _cache) => {
            var _a;
            return ((0, vue_2.unref)(activeCart) !== undefined && (0, vue_2.unref)(activeCart).getSize() > 0)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_name", "Name", "checkout")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_size", "Size", "checkout")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_quantity", "Quantity", "checkout")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_net", "Total net", "checkout")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_gross", "Total gross", "checkout")), 1)
                            ])
                        ]),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(activeCartProducts), (cartProduct) => {
                            var _a;
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: cartProduct.id,
                                class: "mb-3 border-b-2 border-[#E1E1E1]"
                            }, [
                                (0, vue_2.createElementVNode)("div", {
                                    id: `checkout-cart-summary-product-${cartProduct.id}`,
                                    class: "flex py-[6px] bg-white flex-col xl:flex-row"
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_name", "Name", "checkout")), 1),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "grow text-right xl:text-left",
                                            innerHTML: cartProduct.getProductName()
                                        }, null, 8, _hoisted_12)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_size", "Size", "checkout")), 1),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "grow text-right xl:text-left",
                                            innerHTML: cartProduct.getDetailsSize()
                                        }, null, 8, _hoisted_15)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_quantity", "Quantity", "checkout")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)(cartProduct.quantity), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_net", "Total net", "checkout")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((cartProduct.priceNet + cartProduct.priceEco) * cartProduct.quantity, cartProduct.currencyCode)), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_gross", "Total gross", "checkout")), 1),
                                        ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_24, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((cartProduct.priceNet + cartProduct.priceEco) * cartProduct.quantity, cartProduct.currencyCode, { vatPercent: cartProduct.priceVatPercent })), 1))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((cartProduct.priceNet + cartProduct.priceEco) * cartProduct.quantity, (0, vue_2.unref)(customerCurrencyCode), { vatPercent: cartProduct.priceVatPercent })), 1))
                                    ])
                                ], 8, _hoisted_9)
                            ]));
                        }), 128))
                    ]),
                    ((0, vue_2.unref)(activeCart) !== undefined)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_26, [
                            ((0, vue_2.unref)(activeCart).getEcoTotal() > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_27, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_28, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_eco", "ECO", "checkout")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getEcoTotal(), (0, vue_2.unref)(activeCart).getCurrencyCode() || (0, vue_2.unref)(customerCurrencyCode))), 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_net_subtotal", "Net subtotal", "checkout")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getNetTotal(), (0, vue_2.unref)(customerCurrencyCode))), 1)
                            ]),
                            (!((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_33, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_34, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_vat", "VAT", "checkout")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_35, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getGrossTotal() - (0, vue_2.unref)(activeCart).getNetTotal() - (0, vue_2.unref)(activeCart).getEcoTotal(), (0, vue_2.unref)(activeCart).getCurrencyCode() || (0, vue_2.unref)(customerCurrencyCode))), 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                (0, vue_2.createElementVNode)("div", _hoisted_37, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gross_subtotal", "Gross subtotal", "checkout")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_38, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getGrossTotal(), (0, vue_2.unref)(customerCurrencyCode))), 1)
                            ]),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).mandatoryCollectionFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_39, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_40, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_collection_fee", "Collection fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_41, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).mandatoryCollectionFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).courierShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_42, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_43, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_courier_shipping_fee", "Courier shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_44, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).courierShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).transferShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_45, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_46, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_transfer_shipping_fee", "Transfer shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_47, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).transferShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).expressShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_48, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_49, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_express_shipping_fee", "Express shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_50, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).expressShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).hungarianShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_51, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_52, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_hungarian_shipping_fee", "Hungarian shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_53, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).hungarianShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).accessoriesShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_54, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_55, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_accessories_shipping_fee", "Accessories shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_56, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).accessoriesShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).pickUpShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_57, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_58, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_pick_up_shipping_fee", "Pick-up shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_59, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).pickUpShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).glsFlexDeliveryShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_60, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_61, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gls__flex_delivery_shipping_fee", "GLS Flex Delivery shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_62, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).glsFlexDeliveryShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).administrationFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_63, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_64, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_administration_fee", "Administration fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_65, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).administrationFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(extraFees) !== null && (0, vue_2.unref)(extraFees).bexShippingFee > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_66, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_67, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_bex_shipping_fee", "BEX shipping fee", "checkout")), 1),
                                    ((0, vue_2.unref)(extraFees) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_68, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(extraFees).bexShippingFee, (0, vue_2.unref)(extraFees).currencyCode)), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(grossTotalWithExtraFees) !== null)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_69, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_70, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gross_total", "Gross total", "checkout")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_71, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(grossTotalWithExtraFees), (0, vue_2.unref)(customerCurrencyCode))), 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(eprPriceGrossTotal))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_72, [
                            (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                _hoisted_74,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_epr_total", "Of which EPR fee", "checkout")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_75, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(eprPriceGrossTotal), (0, vue_2.unref)(activeCart).getCurrencyCode() || (0, vue_2.unref)(customerCurrencyCode))), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
